import SortUtil from "utils/SortUtil.js";
import type {DropdownOption} from "utils/SortUtil.js";

export const WATERSPORT_OPTIONS: DropdownOption[] = SortUtil.sortDropdownOptions([
  {
    value: "",
    label: "All Sports"
  },
  {
    value: 0,
    label: "Other"
  },
  {
    value: 1,
    label: "Sailing"
  },
  {
    value: 2,
    label: "Windsurf"
  },
  {
    value: 3,
    label: "SUP"
  },
  {
    value: 4,
    label: "Kite"
  },
  {
    value: 5,
    label: "Kayak"
  },
  {
    value: 6,
    label: "Power boat"
  },
  {
    value: 7,
    label: "Jet Ski"
  },
  {
    value: 8,
    label: "Surf"
  },
  {
    value: 9,
    label: "Outrigging"
  },
  {
    value: 10,
    label: "Windfoil"
  },
  {
    value: 11,
    label: "Waterskiing"
  },
  {
    value: 12,
    label: "Wakeboard"
  },
  {
    value: 13,
    label: "Rowing"
  },
  {
    value: 14,
    label: "Kitefoil"
  },
  {
    value: 15,
    label: "Hydrofoil"
  },
  {
    value: 16,
    label: "Foil"
  },
  {
    value: 17,
    label: "Dragon boat"
  },
  {
    value: 18,
    label: "Wingfoil"
  },
  {
    value: 19,
    label: "Pedal"
  },
  {
    value: 20,
    label: "Canoe"
  },
  {
    value: 21,
    label: "Jet Surfing"
  },
  {
    value: 22,
    label: "Surfski"
  },
  {
    value: 23,
    label: "Tiki"
  },
  {
    value: 24,
    label: "Strapless"
  },
  {
    value: 25,
    label: "Snow Kite"
  },
  {
    value: 26,
    label: "Ice Sailing"
  },
  {
    value: 27,
    label: "Wakesurf"
  },
  {
    value: 28,
    label: "eFoil"
  },
  {
    value: 29,
    label: "Prone paddle"
  },
  {
    value: 30,
    label: "Pump foil"
  },
  {
    value: 31,
    label: "Downwind"
  },
  {
    value: 32,
    label: "Parawing"
  },
  {
    value: 33,
    label: "Surfoil"
  }
]);

export const ACTIVITY_FOR_OPTIONS: DropdownOption[] = [
  {
    value: "",
    label: "All"
  },
  {
    value: 0,
    label: "For Fun"
  },
  {
    value: 1,
    label: "Race"
  },
  {
    value: 2,
    label: "Training"
  }
];

const CURRENT_YEAR = new Date().getFullYear();
const YEAR_OPTIONS = Array.from({length: 6}, (_, index) => {
  const year = CURRENT_YEAR - index;
  return {value: year, label: String(year)};
});

export const TIME_INTERVALS_OPTIONS: DropdownOption[] = [
  {
    value: "",
    label: "All Time"
  },
  {
    value: 0,
    label: "Today"
  },
  {
    value: 1,
    label: "Yesterday"
  },
  {
    value: 2,
    label: "This Week"
  },
  {
    value: 3,
    label: "Last Week"
  },
  {
    value: 4,
    label: "This Month"
  },
  {
    value: 5,
    label: "Last Month"
  },
  {
    value: 6,
    label: "Last 3 Months"
  },
  {
    value: 7,
    label: "This Year"
  },
  {
    value: 8,
    label: "Last Year"
  },
  ...YEAR_OPTIONS
];

export const GROUP_TIME_INTERVALS_OPTIONS: DropdownOption[] = [
  {
    value: "daily",
    label: "Daily"
  },
  {
    value: "weekly",
    label: "Weekly"
  },
  {
    value: "monthly",
    label: "Monthly"
  },
  {
    value: "yearly",
    label: "Yearly"
  }
];

export const FEELING_TYPE_OPTIONS: DropdownOption[] = [
  {
    value: "crying",
    label: "crying"
  },
  {
    value: "sad",
    label: "sad"
  },
  {
    value: "straight",
    label: "straight"
  },
  {
    value: "smiley",
    label: "smiley"
  },
  {
    value: "happy",
    label: "happy"
  }
];

export const SPEED_UNIT_OPTIONS: DropdownOption[] = [
  {
    value: "km/h",
    label: "km/h"
  },
  {
    value: "Knots",
    label: "Knots"
  },
  {
    value: "mph",
    label: "mph"
  },
  {
    value: "m/s",
    label: "m/s"
  }
];

export const DISTANCE_UNIT_OPTIONS: DropdownOption[] = [
  {
    value: "Kilometers",
    label: "Kilometers"
  },
  {
    value: "N.Miles",
    label: "N.Miles"
  },
  {
    value: "Miles",
    label: "Miles"
  }
];

export const WIND_UNIT_OPTIONS: DropdownOption[] = [
  {
    value: "km/h",
    label: "km/h"
  },
  {
    value: "Knots",
    label: "Knots"
  },
  {
    value: "mph",
    label: "mph"
  },
  {
    value: "m/s",
    label: "m/s"
  }
];

export const SPLIT_DISTANCE_OPTIONS: DropdownOption[] = [
  {
    value: 100,
    label: "100 m"
  },
  {
    value: 200,
    label: "200 m"
  },
  {
    value: 250,
    label: "250 m"
  },
  {
    value: 500,
    label: "500 m"
  },
  {
    value: 1000,
    label: "1 KM"
  },
  {
    value: 1852,
    label: "1 NM"
  },
  {
    value: 1609,
    label: "1 Mi"
  },
  {
    value: 2000,
    label: "2 KM"
  },
  {
    value: 5000,
    label: "5 KM"
  },
  {
    value: 10000,
    label: "10 KM"
  }
];
